<template>
    <div >
      <div class="tab__container">
          <p>
            <span class="dot-icon__container">
              <i class="far fa-times-circle text-error"></i>
            </span>
            <b class="ml-2">Razón de Cancelación</b>
          </p>

          <div class="row">
            <div class="col-11">
              <ValidationObserver ref="cancelationForm">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomTextArea
                    v-model="cancelReason"
                    label="Comentario:"
                    :placeholder="'Escribe un comentario'"
                    class="my-4 custom-text-area__container"
                    :maxlength="3000"
                    :rows="1"
                    custom-error-msg="Favor de registrar un comentario."
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </ValidationObserver>
            </div>

            <div class="col-1 action-buttons__container">
              <action-button
                variant="outline-danger"
                i="fa fa-times-circle"
                text=""
                class="mr-2"
                @click="hideCancel()"
              />
              <action-button
                variant="success"
                i="fas fa-save"
                text=""
                @click="cancelRequest()"
              />
            </div>
          </div>
        </div>
    </div>
</template>
  
<script>

import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import IconView from "icon-view";
export default {
    name: "CancelRequestGeneral",
    components: {
        ActionButton,
        CustomTextArea,
        IconView,
  },
    data: () => ({
      cancelReason:null  
    }),
    computed: {
       
    },
    methods: {
        async cancelRequest(){
            const isValid = await this.$refs.cancelationForm.validate();
            if (!isValid) return;
                this.$emit('changeStatusRequest',this.cancelReason) 
                this.hideCancel();         
        },
        hideCancel(){
            this.$emit('hideCancelComponent') 
        },
    }
};
</script>

<style scoped>
.tab__container {
  padding: 20px 30px;
}

.action-buttons__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.dot-icon__container {
  padding: 3px 5px;
  border-radius: 50%;
  box-shadow: 0 3px 6px #00000029;
  background: #fff 0 0 no-repeat padding-box;
}

::v-deep .custom-text-area__container textarea {
  min-height: 50px !important;
}
</style>